import React, { useState, useRef, useCallback } from "react";
import { CgArrowsV } from "react-icons/cg";


const ResizableDiv = ({ children, initialHeight = 300, minHeight = 100, className = "" }) => {
  const [height, setHeight] = useState(initialHeight);
  const divRef = useRef(null);
  const isResizing = useRef(false);

  const handleMouseDown = useCallback(() => {
    isResizing.current = true;
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  }, []);

  const handleMouseMove = useCallback((event) => {
    if (!isResizing.current || !divRef.current) return;

    const newHeight = event.clientY - divRef.current.getBoundingClientRect().top;
    if (newHeight >= minHeight) {
      requestAnimationFrame(() => setHeight(prevHeight => (prevHeight !== newHeight ? newHeight : prevHeight)));
    }
  }, [minHeight]);

  const handleMouseUp = useCallback(() => {
    isResizing.current = false;
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  }, []);

  return (
    <div ref={divRef} style={{ height: `${height}px` }} className={`relative ${className}`}>
        {children}

        {/* Centered Resize Handle */}
        <div
        className="w-12 h-8 border-2 shadow-sm bg-[#F5F5F5] cursor-ns-resize absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 rounded-md flex items-center justify-center"
        onMouseDown={handleMouseDown}
        >
            <CgArrowsV className="text-xl text-gray-400" />
        </div>
    </div>
  );
};

export default ResizableDiv;